namespace Gamification.Gamification {
    export interface UtentiApiForm {
        UserId: Serenity.IntegerEditor;
        IdApi: Serenity.IntegerEditor;
        Bloccato: Serenity.BooleanEditor;
    }

    export class UtentiApiForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.UtentiApi';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!UtentiApiForm.init)  {
                UtentiApiForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.BooleanEditor;

                Q.initFormType(UtentiApiForm, [
                    'UserId', w0,
                    'IdApi', w0,
                    'Bloccato', w1
                ]);
            }
        }
    }
}
